import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import Slider from "rc-slider";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {langRegister} from "../../services/langRegister";

const Handle = Slider.Handle;

class DropdownSliderDuration extends Component {

    constructor(props) {
        super(props);
        this.state = {
            caption: this.props.caption,
            options: this.props.options,
            disabled: this.props.disabled,
            error: this.props.error,
            value: this.props.value,
            currency: this.props.currency,
            price: this.props.price
        };
    };

    componentWillMount() {};

    componentDidMount(){}

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            caption: nextProps.caption,
            options: nextProps.options,
            disabled: nextProps.disabled,
            error: nextProps.error,
            value: nextProps.value,
            currency: nextProps.currency,
            price: nextProps.price
        });
    }

    functions = {
        increase: () => {
            this.state.price++;
            this.props.onChange(this.state.price, this.state.value);
        },
        decrease: () => {
            let value = JSON.parse(JSON.stringify(this.state.price));
            value--;
            if(value === 0 || value > 0){
                this.state.price--;
                this.props.onChange(this.state.price, this.state.value);
            }
        },
        set: (value) => {
            this.props.onChange(value, this.state.value);
        },
        duration: (value) => {
            this.props.onChange(0, value);
        }
    };

    renders = {
        handle: (props) => {
            const {value, ...restProps} = props;
            return (<Handle value={value} {...restProps}/>);
        },
        number: (number) => {
            try {
                if(number < 1 && salesChannelRegister.get("name") !== "yieldlock"){
                    return this.state.caption;
                }else{
                    number = Math.round(number * 100) / 100;
                    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                }
            } catch (e) {
                return ("...")
            }
        },
        text: (item) => {
            return langRegister.get("dropdown-slider-duration", item);
        },
    };

    render() {
        return (
            <div className={Styles.slidersContainer}>
                <div className={Styles.sliderInner}>
                    <div className={Styles.sliderInnerContainer}>
                        <div onClick={() => this.functions.decrease()}
                             className={Styles.sliderInnerContainerCircle}>
                            <img className={Styles.sliderInnerContainerCircleMinus}
                                 src={require("../../assets/images/minus_icon_white_small.png")}/>
                        </div>
                        <div className={Styles.sliderInnerContainerInner}>
                            {
                                salesChannelRegister.get("name") === "propertybooster" &&
                                <Slider
                                    handleStyle={{backgroundColor: "#33b8cf"}}
                                    trackStyle={{backgroundColor: "#33b8cf"}}
                                    index={1}
                                    step={1}
                                    min={0}
                                    max={JSON.parse(this.state.value).max}
                                    title={"title"}
                                    titleTwo={"title"}
                                    value={this.state.price}
                                    onChange={(value) => this.functions.set(value)}
                                    handle={this.renders.handle}
                                />
                            }
                            {
                                salesChannelRegister.get("name") === "yieldlock" &&
                                <Slider
                                    handleStyle={{backgroundColor: "#00273A"}}
                                    trackStyle={{backgroundColor: "#00273A"}}
                                    index={1}
                                    step={1}
                                    min={0}
                                    max={JSON.parse(this.state.value).max}
                                    title={"title"}
                                    titleTwo={"title"}
                                    value={this.state.price}
                                    onChange={(value) => this.functions.set(value)}
                                    handle={this.renders.handle}
                                />
                            }
                            {
                                salesChannelRegister.get("name") === "boostabostad" &&
                                <Slider
                                    handleStyle={{backgroundColor: "#7ECF5B"}}
                                    trackStyle={{backgroundColor: "#7ECF5B"}}
                                    index={1}
                                    step={1}
                                    min={0}
                                    max={JSON.parse(this.state.value).max}
                                    title={"title"}
                                    titleTwo={"title"}
                                    value={this.state.price}
                                    onChange={(value) => this.functions.set(value)}
                                    handle={this.renders.handle}
                                />
                            }
                        </div>
                        <div onClick={() => this.functions.increase()} className={cx(Styles.sliderInnerContainerCircle, Styles.sliderInnerContainerCircleRight)}>
                            <img className={Styles.sliderInnerContainerCirclePlus} src={require("../../assets/images/plus_sign_white_small.png")}/>
                        </div>
                        <div className={Styles.sliderInnerContainerInnerRail}/>
                        <div className={Styles.sliderInnerContainerInnerRailLeft}/>
                    </div>
                    <div className={Styles.sliderInnerBoxes}>
                        <div className={cx(Styles.sliderValue,Styles.sliderValueLong)}>
                            <div className={Styles.sliderValueTextPrice}>
                                {this.renders.number(this.state.price)}
                            </div>
                        </div>
                        <div className={cx(Styles.sliderValueDivider)}>
                            /
                        </div>
                        <div className={cx(Styles.sliderValue,Styles.sliderValueLong)}>
                            <div className={Styles.sliderValueText}>
                                {this.state.currency}
                            </div>
                        </div>
                        {
                            <div className={
                                cx(Styles.sliderValueDropdown, Styles.sliderValueDropdownLong, Styles.sliderValueDropdownExtra,
                                    {
                                        [Styles.sliderValueDropdownError]: this.state.error,
                                    })
                            }>
                                <select
                                    value={this.state.duration}
                                    className={Styles.sliderValueDropdownSelection}
                                    onChange={(event) => this.functions.duration(event.target.value)}>
                                    <option value="-1" disabled>{this.renders.text("item_1")}</option>
                                    {
                                        this.state.options.map((item) => {
                                            return (
                                                <option value={JSON.stringify(item)}>{item.title}</option>
                                            )
                                        })
                                    }
                                </select>
                                {
                                    this.state.value &&
                                    <div className={Styles.sliderValueDropdownText}>{JSON.parse(this.state.value).title}</div>
                                }
                                {
                                    !this.state.value &&
                                    <div className={Styles.sliderValueDropdownText}>{this.renders.text("item_1")}</div>
                                }
                                {
                                    !this.state.error &&
                                    <img className={Styles.sliderValueDropdownArrow} src={require("../../assets/images/arrow-down.svg")}/>
                                }
                                {
                                    this.state.error &&
                                    <img className={Styles.sliderValueDropdownArrow} src={require("../../assets/images/arrow-down-error.svg")}/>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default DropdownSliderDuration;


// WEBPACK FOOTER //
// ./src/components/dropdown-slider-duration/component.js